import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import {
  createSignerSettingsSlice,
  SignerSettingsSlice,
} from './slices/signer-settings.slice';
import {
  createPdfDocumentSlice,
  PdfDocumentSlice,
} from './slices/pdf-document.slice';
import {
  createPlaceholdersSlice,
  PlaceholdersSlice,
} from './slices/placeholders.slice';
import {
  createPlaceholdersHistorySlice,
  PlaceholdersHistorySlice,
} from './slices/placeholders-history.slice';
import { MaybeMondayId } from '@/interfaces/interfaces';

export interface StoreState {
  itemId: MaybeMondayId | null;
  setItemId: (itemId: MaybeMondayId) => void;
  boardId: number | null;
  setBoardId: (boardId: number) => void;
  signerSettings: SignerSettingsSlice;
  pdfDocument: PdfDocumentSlice;
  placeholders: PlaceholdersSlice;
  placeholdersHistory: PlaceholdersHistorySlice;
}

type StoreMutators = [['zustand/immer', never], ['zustand/devtools', never]];

const createStore: StateCreator<StoreState, StoreMutators> = (
  set,
  get,
  store,
) => ({
  itemId: null,
  setItemId: (itemId: MaybeMondayId) => set((state) => ({ ...state, itemId })),
  boardId: null,
  setBoardId: (boardId: number) => set((state) => ({ ...state, boardId })),
  signerSettings: createSignerSettingsSlice(set, get, store),
  pdfDocument: createPdfDocumentSlice(set, get, store),
  placeholders: createPlaceholdersSlice(set, get, store),
  placeholdersHistory: createPlaceholdersHistorySlice(set, get, store),
});

export const usePdfEditorStore = create<StoreState>()(
  devtools(immer(createStore), {
    name: 'pdf-editor-store',
    enabled: process.env.NODE_ENV === 'development',
  }),
);
